import axios from "axios";

const state = {
  internal_purchase_orders: [],
  loading: false,
};

const getters = {
  internal_purchase_orders: (state) => state.internal_purchase_orders,
  loading: (state) => state.loading,
};

const actions = {
  async get_internal_purchase_orders({ commit }, branchId) {
    commit("SET_LOADING", true);
    try {
      const params = branchId ? { branch_id: branchId } : {};
      const response = await axios.get("internal_purchase_orders", { params });
      commit("SET_INTERNAL_PURCHASE_ORDERS", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching internal purchase orders:", error);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async add_internal_purchase_order({ commit }, payload) {
    try {
      let formData, onUploadProgress;
      if (payload && payload._formData) {
        formData = payload._formData;
        onUploadProgress = payload.onUploadProgress;
      } else {
        formData = payload;
      }

      const isFormData = formData instanceof FormData;

      const config = isFormData
        ? {
            headers: { "Content-Type": "multipart/form-data" },
            ...(onUploadProgress ? { onUploadProgress } : {}),
          }
        : {};

      const response = await axios.post(
        "internal_purchase_order",
        formData,
        config
      );
      commit("ADD_INTERNAL_PURCHASE_ORDER", response.data);
      return response.data;
    } catch (error) {
      console.error("Error adding internal purchase order:", error);
      throw error;
    }
  },

  async update_internal_purchase_order({ commit }, payload) {
    try {
      let formData, onUploadProgress;
      if (payload && payload._formData) {
        formData = payload._formData;
        onUploadProgress = payload.onUploadProgress;
      } else {
        formData = payload;
      }

      const isFormData = formData instanceof FormData;
      const id = isFormData ? formData.get("id") : formData.id;

      let response;
      if (isFormData) {
        response = await axios.post(`internal_purchase_order/${id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          ...(onUploadProgress ? { onUploadProgress } : {}),
        });
      } else {
        response = await axios.put(`internal_purchase_order/${id}`, formData);
      }

      commit("UPDATE_INTERNAL_PURCHASE_ORDER", response.data);
      return response.data;
    } catch (error) {
      console.error("Error updating internal purchase order:", error);
      throw error;
    }
  },

  async delete_attachment({ commit }, { poId, attachmentId }) {
    try {
      await axios.delete(`internal_purchase_order_attachment/${attachmentId}`);
      commit("REMOVE_ATTACHMENT", { poId, attachmentId });
    } catch (error) {
      console.error("Error deleting attachment:", error);
      throw error;
    }
  },

  async delete_internal_purchase_order({ commit }, id) {
    try {
      await axios.delete(`internal_purchase_order/${id}`);
      commit("DELETE_INTERNAL_PURCHASE_ORDER", id);
    } catch (error) {
      console.error("Error deleting internal purchase order:", error);
      throw error;
    }
  },
};

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_INTERNAL_PURCHASE_ORDERS(state, orders) {
    state.internal_purchase_orders = orders;
  },

  ADD_INTERNAL_PURCHASE_ORDER(state, order) {
    state.internal_purchase_orders.unshift(order);
  },

  UPDATE_INTERNAL_PURCHASE_ORDER(state, updatedOrder) {
    const index = state.internal_purchase_orders.findIndex(
      (order) => order.id == updatedOrder.id
    );
    if (index !== -1) {
      state.internal_purchase_orders.splice(index, 1, updatedOrder);
    }
  },

  DELETE_INTERNAL_PURCHASE_ORDER(state, id) {
    state.internal_purchase_orders = state.internal_purchase_orders.filter(
      (order) => order.id != id
    );
  },

  REMOVE_ATTACHMENT(state, { poId, attachmentId }) {
    const order = state.internal_purchase_orders.find((o) => o.id == poId);
    if (order && order.attachments) {
      order.attachments = order.attachments.filter((a) => a.id != attachmentId);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
